import classNames from 'classnames'
import type { ReasonCopy } from '../freeform-unassociated-reasons.ts'
import * as styles from './freeform-run-styles.css.ts'

export type StatCellProps = {
  value: number
  label: string
  className?: string
}

/** One count in a run's totals. */
export const StatCell: React.FC<StatCellProps> = ({ value, label, className }) => (
  <div className={className}>
    <span className={styles.statValue}>{value}</span>
    <span className={styles.statLabel}>{label}</span>
  </div>
)

export type MissGroupsFinding = {
  key: string
  /** The report's own id for it, which only the run's stream knows. */
  label?: string
  title: string
  rationale?: string
}

export type MissGroupsProps = {
  groups: { reason: string; copy: ReasonCopy; findings: MissGroupsFinding[] }[]
  /** Spell out each reason under its label, rather than only on hover. */
  isDescribed?: boolean
  className?: string
  groupClassName?: string
}

/** The findings no repository could take, grouped by why: not judged safe, so a person should look. */
export const MissGroups: React.FC<MissGroupsProps> = ({ groups, isDescribed = false, className, groupClassName }) => (
  <div className={className}>
    {groups.map(group => (
      <div key={group.reason} className={classNames(styles.missGroup, groupClassName)}>
        <span className={styles.reason} title={isDescribed ? undefined : group.copy.description}>
          {group.copy.label}
        </span>
        {isDescribed && <p className={styles.reasonText}>{group.copy.description}</p>}
        <ul className={styles.missList}>
          {group.findings.map(finding => (
            <li key={finding.key} className={styles.miss({ hasId: finding.label !== undefined })}>
              {finding.label !== undefined && <span className={styles.findingId}>{finding.label}</span>}
              <span className={styles.missTitle}>{finding.title}</span>
              {finding.rationale && <span className={styles.missWhy}>{finding.rationale}</span>}
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
)
